import { Assets, Texture, Rectangle } from 'pixi.js';
import { parseTpsheet } from './tpsheet';

/** A loaded TexturePacker atlas: the base texture plus a frame Texture per sprite name. */
export interface Atlas {
  base: Texture;
  frames: Map<string, Texture>;
}

/**
 * Loads a PNG + its .tpsheet and slices it into per-frame Pixi textures.
 *
 * TexturePacker/Unity store frame rects with a BOTTOM-LEFT origin, whereas Pixi uses TOP-LEFT, so
 * by default we flip Y (pixiY = sheetHeight - y - h). If avatars ever look vertically mismatched,
 * pass flipY=false.
 */
export async function loadAtlas(pngUrl: string, tpsheetUrl: string, flipY = true): Promise<Atlas> {
  const [base, tpText] = await Promise.all([
    Assets.load<Texture>(pngUrl),
    fetch(tpsheetUrl).then((r) => r.text()),
  ]);
  const sheet = parseTpsheet(tpText);
  const sheetH = sheet.height || base.height;
  const frames = new Map<string, Texture>();
  for (const f of sheet.frames) {
    const y = flipY ? sheetH - f.y - f.h : f.y;
    frames.set(f.name, new Texture({ source: base.source, frame: new Rectangle(f.x, y, f.w, f.h) }));
  }
  return { base, frames };
}
